import { styled } from "styled-components";

export const CountriesWrapper = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
`;

export const GroupsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CountriesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

  ${({ theme }) => theme.breakpoints.sm.query} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const Country = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CountryIcon = styled.div`
  height: fit-content;
  width: 24px;
`;

export const CountryTitle = styled.p``;
